import { Text, Table, Box, Icon } from '@quintoandar-tokko/jopijs';
import styles from '../dashboardTables.module.scss';

export default function HeaderCell({
  title,
  subtitle,
  field,
  sortBy = null,
  sortDirection = null,
  ...rest
}) {
  const getIcon = () => {
    if (field !== sortBy) return 'icon-ordenar';
    return sortDirection === 'asc' ? 'icon-colapsar' : 'icon-dropdown';
  };

  return (
    <Table.HeaderItemDefault
      className={styles.tableHeaderItemWrapper}
      data-clickable={Boolean(field)}
      {...rest}
    >
      <Box className={styles.tableHeaderItem}>
        <Box className={styles.tableHeaderItemTexts}>
          <Text className={styles.tableTitle}>{title}</Text>

          {subtitle && <Text className={styles.tableSubtitle}>{subtitle}</Text>}
        </Box>
        {field && <Icon icon={getIcon()} className={styles.sortIcon} />}
      </Box>
    </Table.HeaderItemDefault>
  );
}
